import "./auth.css";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { resetPassword } from "./authServices";
import { useNavigate } from "react-router-dom";
import { Form } from "react-bootstrap";
import login from "../../Assets/login.svg";
import logo from "../../Assets/logo.svg";
import { AiFillEye } from "react-icons/ai";
import { FaEyeSlash } from "react-icons/fa";

export default function ResetPassword() {
  const navigate = useNavigate();
  const { register, handleSubmit } = useForm();
  const [passwordShown, setPasswordShown] = useState(false);
  const [passwordShowns, setPasswordShowns] = useState(false);

  const togglePasswordVisiblity = () => {
    setPasswordShown(passwordShown ? false : true);
  };
  
  const togglePasswordVisiblitys = () => {
    setPasswordShowns(passwordShowns ? false : true);
  };
  const onSubmit = (data) => {
    const { password, Confirmation } = data;
    if (password === Confirmation) {
      resetPassword(password, navigate);
    } else {
      toast.error("Mots de passe ne correspond pas");
    }
  };

  return (
    <div className="container-fluid p-0 " id="login">
      <div className="row d-flex justify-content-center align-items-center w-100 min-vh-100">
        <div className="col-lg-6  p-0 pt-0 d-none d-lg-block">
          <div className="container-bg style-border  d-flex justify-content-center align-items-center w-100 min-vh-100 ">
            <img src={login} className="img-fluid imLogin" />
          </div>
        </div>

        <div className="col-lg-6  p-4 text-center min-vh-100">
          <div className="container-img w-100 d-flex justify-content-center text-center">
            <img src={logo} className="img-fluid logLogin " />
          </div>
          <div className="tiitle-h2">
            <h2>Reinnitialisation mots de passe</h2>
          </div>
          <Form onSubmit={handleSubmit(onSubmit)} className="mx-auto">
            <Form.Group className="position-relative" controlId="formBasicEmail">
              <Form.Label>Nouveau mots de passe</Form.Label>
              <Form.Control
                {...register("password")}
                type={passwordShown ? "text" : "password"}
                placeholder="password"
              />
              {
                  passwordShown === false ?
                  < AiFillEye
                    className="position-absolute eye"
                    onClick={togglePasswordVisiblity}
                    size={20}
                  />
                  :
                  <FaEyeSlash
                  className="position-absolute eye"
                  onClick={togglePasswordVisiblity}
                  size={20}
                  />
                }
            </Form.Group>

            <Form.Group className="mb-3 position-relative" controlId="formBasicPassword">
              <Form.Label>Confirmation</Form.Label>
              <Form.Control
                {...register("Confirmation")}
                type={passwordShowns ? "text" : "password"}
                placeholder="Confirmation"
              />
              {
                  passwordShowns === false ?
                  < AiFillEye
                    className="position-absolute eye"
                    onClick={togglePasswordVisiblitys}
                    size={20}
                  />
                  :
                  <FaEyeSlash
                  className="position-absolute eye"
                  onClick={togglePasswordVisiblitys}
                  size={20}
                  />
                }
            </Form.Group>
            <button
              onClick={() => navigate("/")}
              className="block-btn1 btn btn-md-lg me-2"
            >
              Annuler
            </button>
            <button type="submit" className="block-btn btn btn-md-lg mS-2">
              Reinitialiser
            </button>
          </Form>
        </div>
      </div>
    </div>
  );
}
